import script from "./SignUpWithEmailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpWithEmailPage.vue?vue&type=script&setup=true&lang=ts"

import "./SignUpWithEmailPage.vue?vue&type=style&index=0&id=85a9c20e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85a9c20e"]])

export default __exports__